import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  @Output() featureSelected = new EventEmitter<string>();

  onSelect(featureSelected: string){
    this.featureSelected.emit(featureSelected);
  }

}



// WEBPACK FOOTER //
// C:/gitHub/cookbook/src/app/components/header/header.component.ts